import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Input } from '../../components/forms/Input';
import { useAuth } from '../../context/AuthContext';
import { usePageTitle } from '../../hooks/usePageTitle';

export function Login() {
	usePageTitle("Admin Login");
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const { login } = useAuth();
	const navigate = useNavigate();

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		try {
			const success = await login(username, password);
			if (success) {
				navigate('/admin');
			} else {
				setError('Invalid username or password');
			}
		} catch (err) {
			setError('Login failed. Please try again.');
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
			<div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
				<h1 className="text-3xl font-bold text-center mb-8">Admin Login</h1>

				<form onSubmit={handleSubmit} className="space-y-4">
					<Input
						label="Username"
						value={username}
						onChange={(e) => setUsername(e.target.value)}
						required
						autoComplete="username"
					/>

					<Input
						label="Password"
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						required
						autoComplete="current-password"
					/>

					{error && (
						<div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded">
							{error}
						</div>
					)}

					<Button
						type="submit"
						variant="primary"
						className="w-full"
						loading={loading}
					>
						Login
					</Button>
				</form>
			</div>
		</div>
	);
}
